/** Saves a text file through the browser's download (save export, broken-save rescue). */
export function downloadText(filename: string, text: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([text], { type: 'application/json' }));
  a.download = filename;
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(a.href);
  }, 1000);
}

/** `little-cozy-town-20261021.json` (content-schemas §11.7); `suffix` marks e.g. a broken save. */
export function saveFileName(now: Date, suffix = ''): string {
  const day = now.toISOString().slice(0, 10).replaceAll('-', '');
  return `little-cozy-town-${day}${suffix}.json`;
}
